module.exports = __webpack_public_path__ + "img/Clip.2f0d22d9.svg";